import { APIConfiguration } from '../../../utils/apiConfiguration'
import interceptedAxios from '../../../utils/interceptedAxios'

export interface SaveDefaultViewRequest {
  assetDashBoardDefaultView: Array<{
    widgetId: string
    displayname: string
    devices: any[]
    assets: any[]
  }>
}

export interface DeviceData {
  deviceId: string
  cimCodeIds: string[]
  kpidefinitionIds: string[]
}

export interface DeviceDataWidget {
  widgetId: string
  displayname: string
  devices: DeviceData[]
}

export interface DeviceDataWidgetData {
  assetDashBoardDefaultView: DeviceDataWidget[]
}

export interface Data {
  assetId: string
  dashboardLevel: string
  assetDashBoardDefaultView: DeviceDataWidgetData
}

export interface ApiResponse {
  http_status: number
  error: boolean
  data?: Data
}

export type GetSaveDefaultViewResponce = DeviceDataWidgetData
export type GetSaveDefaultViewResponceAPIData = ApiResponse

export async function getSaveDefaultViewService (
  deviceId: string,
  onSuccess: (SaveDefaultViewResponce: any, httpStatus: number) => any,
  onFailure: (errorMessage: any, httpStatus: number) => any
): Promise<void> {
  const url = `/asset-data-service/api/v1/udp/tiq/assets/data/interval/assets/${deviceId}/dashboard`
  interceptedAxios
    .get(url, { timeout: 10000 })
    .then((response) => {
      if (response.status === 200) {
        console.log('response.data device dashboard', response.data)
        const responseData: ApiResponse = response.data
        if (responseData.data !== null && responseData.data !== undefined) {
          onSuccess(responseData.data, response.status)
        } else {
          onFailure('Data is null or undefined', response.status)
        }
      }
    })
    .catch((error) => {
      if (error.response !== undefined) {
        if (error.response.data !== undefined) {
          onFailure(error.response.data.error_message, error.response.status)
        } else {
          onFailure(error.response.statusText, error.response.status)
        }
      } else {
        if (error.code === 'ECONNABORTED') { onFailure(error.message, APIConfiguration.REQUEST_TIMEOUT) } else onFailure('Network Failure', error.status)
      }
    })
}
